import { Eye } from 'lucide-react';
import { useDocument } from '../documents/DocumentContext';
import { DocumentSchema } from '../documents/types';
import {
    PolicyDocumentView,
    PolicyDocumentMeta,
} from '../department-policies/read/PolicyDocumentView';

interface TemplatePreviewPanelProps {
    schema: DocumentSchema;
    title: string;
}

export function TemplatePreviewPanel({
    schema,
    title,
}: TemplatePreviewPanelProps) {
    const { data } = useDocument();

    const meta: PolicyDocumentMeta = {
        title,
        status: 'draft',
    };

    return (
        <>
            <p className="text-[10px] font-semibold tracking-widest uppercase text-muted-foreground flex items-center gap-1.5 mb-4">
                <Eye className="w-3 h-3" />
                Template preview
            </p>
            <PolicyDocumentView
                schema={schema}
                data={data}
                meta={meta}
                hideToolbar
            />
        </>
    );
}
